import { render, staticRenderFns } from "./RealnameForm.vue?vue&type=template&id=106df9d0&scoped=true"
import script from "./RealnameForm.vue?vue&type=script&lang=js"
export * from "./RealnameForm.vue?vue&type=script&lang=js"
import style0 from "./RealnameForm.vue?vue&type=style&index=0&id=106df9d0&prod&scoped=true&lang=less"
import style1 from "./RealnameForm.vue?vue&type=style&index=1&id=106df9d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106df9d0",
  null
  
)

export default component.exports